export class ExcelRangecellValueShow {
  splitCells?: boolean;
  splitCellNum?: number;
  splitValueSeparator?: string;
  value?: string;
  attachedFormCode?: string;
  attachedFormWrite?: boolean;
  newFontSize?: number;
}
